import React, { useRef } from 'react';

type LongPressGuardProps = {
  children: React.ReactElement<any>;
  onLongPress: () => void;
  onClick?: () => void;
  delay?: number;
};

export function LongPressGuard({
  children,
  onLongPress,
  onClick,
  delay = 5000,
}: LongPressGuardProps) {
  const timerRef = useRef<number | null>(null);
  const longPressTriggeredRef = useRef(false);

  const startPress = () => {
    longPressTriggeredRef.current = false;

    timerRef.current = window.setTimeout(() => {
      longPressTriggeredRef.current = true;
      onLongPress();
    }, delay);
  };

  const endPress = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  };

  const handleClick = (e: React.MouseEvent) => {
    if (longPressTriggeredRef.current) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    onClick?.();
  };

  return React.cloneElement(children, {
    onPointerDown: startPress,
    onPointerUp: endPress,
    onPointerLeave: endPress,
    onPointerCancel: endPress,
    onClick: handleClick,
    style: {
      touchAction: 'manipulation',
      ...children.props.style,
    },
  });
}